import * as React from 'react';
import MediaQuery from 'react-responsive';
import {
    DESKTOP_VERSION_SELECTOR,
    MOBILE_VERSION_SELECTOR,
    root
} from '@estee/elc-universal-utils';
import { IResponsive } from '../interfaces/IResponsive';

const wrapperStyles = {
    display: 'none'
};

export const Mobile = ({ children, maxWidth }: IResponsive) => {
    return root.__ssr ? (
        <div className={`${MOBILE_VERSION_SELECTOR} elc-mobile-version`} style={wrapperStyles}>
            {children()}
        </div>
    ) : (
        <MediaQuery maxWidth={maxWidth} children={children()} />
    );
};

export const Desktop = ({ children, minWidth, maxWidth }: IResponsive) => {
    return root.__ssr ? (
        <div className={`${DESKTOP_VERSION_SELECTOR} elc-desktop-version`} style={wrapperStyles}>
            {children()}
        </div>
    ) : (
        <MediaQuery minWidth={minWidth} children={children()} maxWidth={maxWidth} />
    );
};

export const LargeScreen = ({ children, minWidth, maxWidth }: IResponsive) => {
    return root.__ssr ? (
        <div className={`${DESKTOP_VERSION_SELECTOR} elc-large-version`} style={wrapperStyles}>
            {children()}
        </div>
    ) : (
        <MediaQuery minWidth={minWidth} maxWidth={maxWidth} children={children()} />
    );
};

export const ExtraLargeScreen = ({ children, minWidth, maxWidth }: IResponsive) => {
    return root.__ssr ? (
        <div className={`${DESKTOP_VERSION_SELECTOR} elc-extralarge-version`} style={wrapperStyles}>
            {children()}
        </div>
    ) : (
        <MediaQuery minWidth={minWidth} maxWidth={maxWidth} children={children()} />
    );
};
